export enum PaletteContext {
  DEFAULT = 'DEFAULT',
  CHECK_YOUR_ANSWER = 'CHECK_YOUR_ANSWER',
  TABLE_VIEW = 'TABLE_VIEW',
}
